import React from "react";
import { ProjectState } from "./project";

export const ProjectContext = React.createContext({} as ProjectState);
